import { uploadImage } from "pages/MarketingPages/pagesApi";

/**
 * Inline images always go to R2 and enter the body as a served URL — never as
 * base64, which the API sanitizer drops by scheme (DAB-830). The three ways an
 * image can arrive — the toolbar button, a drop, a paste — all come through
 * here, so all three behave the same, alt prompt included.
 */

const ALT_PROMPT = "Алтернативен текст (описание за достъпност):";

/** The image files carried by a drop's dataTransfer or a paste's clipboardData. */
export const imageFilesFrom = (transfer) =>
  Array.from(transfer?.files || []).filter((file) => file.type.startsWith("image/"));

/** Upload one file and ask for its alt text. Throws if the upload gives no URL. */
export const uploadInlineImage = async (file) => {
  const url = await uploadImage(file);
  if (!url) throw new Error("Качването не върна URL адрес");
  const alt = window.prompt(ALT_PROMPT, "") || "";
  return { src: url, alt };
};

/** Open the file picker and resolve with the chosen file, or null if cancelled. */
export const pickImageFile = () =>
  new Promise((resolve) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    // A dismissed picker fires `cancel`, not `change` — without it the promise
    // (and the caller awaiting it) would be retained forever.
    input.onchange = () => resolve((input.files && input.files[0]) || null);
    input.oncancel = () => resolve(null);
    input.click();
  });
